module.exports = __webpack_public_path__ + "img/Service.1c3d3213.gif";